export default __webpack_public_path__ + "static/100--stacked-bar-7830ce12af4dcaf9d3f03b5e7f313708.png";